<template>
  <div :class="{ 'card simple-search': insideCard }">
    <form
      :class="{
        'border-round overflow-hidden': rounded,
        'shadow-md': shadow,
        disabled,
      }"
      class="text-base"
      @submit.prevent="submit"
    >
      <div class="relative flex">
        <input
          name="search"
          ref="search"
          v-model.trim="localValue"
          :disabled="disabled"
          :placeholder="placeholder"
          :autocomplete="autocomplete ? 'on' : 'off'"
          :class="[inputClass, disabled ? 'disabled' : '']"
          class="flex-grow rp50 text-lighter-gray border-none font-inherit"
        />

        <div class="absolute flex full-height inset-y-auto right-0">

          <div v-if="isSearching" class="flex items-center justify-center">
            <span class="text-gray-500 rmr100">
              <i class="fas fa-spinner rotate" ></i>
            </span>
          </div>

          <div v-else class="flex items-center justify-center">
            <a v-if="value && !hideClearIcon" @click="clearSearchFraze" class="rmr50 text-gray-500 hover:text-red-900 cursor-pointer" :class="{disabled}">
              <i class="fas fa-times" :class="{disabled}"></i>
            </a>

            <button v-if="!hideSearchIcon" type="submit" class="submitBtn rmr75" :class="{disabled}">
              <i class="fas fa-search" :class="{disabled}"></i>
            </button>
          </div>

        </div>

      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
    insideCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Search",
    },
    autocomplete: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
      default: "",
    },
    hideSearchIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideClearIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    focus: {
      type: Boolean,
      required: false,
      default: false,
    },
    blur: {
      type: Boolean,
      required: false,
      default: false,
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    shadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSearching: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      searchKey: null,
      dispatched: false,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  watch: {
    focus(newValue) {
      if (newValue && this.$refs.search !== document.activeElement)
        this.$refs.search.focus();
    },
    blur(newValue) {
      if (newValue && this.$refs.search === document.activeElement)
        this.$refs.search.blur();
    },
  },
  methods: {
    clearSearchFraze() {
      this.dispatched = false;
      this.localValue = "";
      this.$emit("clearSearch");
    },
    submit(e) {
      if (this.disabled) return;
      this.dispatched = true;
      this.$emit(
        "search",
        e.target.elements.search.value && e.target.elements.search.value.trim()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.card.simple-search {
  width: 350px;
  margin-bottom: 0px;

  @media only screen and (max-width: 970px) {
    .col-md-4,
    .col-md-8 {
      width: 100%;
    }
  }
}

.overflow-hidden {
  overflow: hidden;
}

.inset-y-auto {
  top: auto;
  bottom: auto;
}

.right-0 {
  right: 0;
}

.font-inherit {
  font-family: inherit;
}

.text-gray-500 {
  --text-opacity: 1;
  color: #a0aec0;
  color: rgba(160, 174, 192, var(--text-opacity));
}

.hover\:text-red-900:hover {
  --text-opacity: 1;
  color: #742a2a;
  color: rgba(116, 42, 42, var(--text-opacity));
}

.border-round-xs {
  border-radius: 6px;
}

.submitBtn {
  padding: 0;
  line-height: 0.5;
  color: inherit;
  cursor: pointer;
  background: none;
  border: none;
  box-shadow: none;
}

.submitBtn:hover {
  --text-opacity: 1;
  color: #2985a3;
  color: rgba(41, 133, 163, var(--text-opacity));
}

.text-lighter-gray {
  color: #9b9b9b;
}

.placeholder-current::placeholder {
  color: currentColor;
}
</style>
